module.exports = __webpack_public_path__ + "static/media/SpectralCalculator-Library-Excel-Input.1c0e3f41.xlsx";